// extracted by mini-css-extract-plugin
export var notificationHost = "_k7-0";